import { useRef } from 'react';

import { AddressForm } from '../AddressElement';

export interface AddressElementRef {
  isValid: () => boolean;
  validate: () => Promise<any>;
  values: AddressForm;
}

export function useAddressElementRef() {
  const ref = useRef<AddressElementRef>();

  return {
    AddressElementRef: ref,
  };
}
